/* =========================================================================
   Boho Vana (bv-) Tabbed Collection Logic
   ========================================================================= */

document.addEventListener('DOMContentLoaded', () => {
  const tabContainers = document.querySelectorAll('.bv-tabbed-collection');

  tabContainers.forEach(container => {
    const tabButtons = container.querySelectorAll('.bv-tab-btn');
    const tabPanels = container.querySelectorAll('.bv-tab-panel');

    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-target');

        // Remove active class from all buttons and panels in this section
        tabButtons.forEach(btn => btn.classList.remove('is-active'));
        tabPanels.forEach(panel => panel.classList.remove('is-active'));

        // Add active class to clicked button and target panel
        button.classList.add('is-active');
        const targetPanel = container.querySelector(`#${targetId}`);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });
  });
});
